import { useQuery } from "@tanstack/react-query";
import { baseUrl } from "components/shared/apiCrudBuilder";
import { AuthenticationContext } from "components/context/AuthenticationProvider";
import { useContext } from "react";

const path = `${baseUrl}/address`;

export const useAllAddressCountries = (options) => {
  const { appAxios } = useContext(AuthenticationContext);

  return useQuery({
    ...options,
    queryKey: ["all_AddressCountries"],
    queryFn: () => appAxios.get(`${path}-countries/`).then((res) => res.data),
    cacheTime: 3600000,
    staleTime: 3600000,
  });
};

export const useAllAddressAreas = (options) => {
  const { appAxios } = useContext(AuthenticationContext);

  return useQuery({
    ...options,
    queryKey: ["all_AddressAreas"],
    queryFn: () => appAxios.get(`${path}-areas/`).then((res) => res.data),
    cacheTime: 3600000,
    staleTime: 3600000,
  });
};

export const useAllAddressLocalities = (options) => {
  const { appAxios } = useContext(AuthenticationContext);

  return useQuery({
    ...options,
    queryKey: ["all_AddressLocalities"],
    queryFn: () => appAxios.get(`${path}-localities/`).then((res) => res.data),
    cacheTime: 3600000,
    staleTime: 3600000,
  });
};
